var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 15.5455V2.45455C1 2.06878 1.15325 1.69881 1.42603 1.42603C1.69881 1.15325 2.06878 1 2.45455 1H15.5455C15.9312 1 16.3012 1.15325 16.574 1.42603C16.8468 1.69881 17 2.06878 17 2.45455V15.5455C17 15.9312 16.8468 16.3012 16.574 16.574C16.3012 16.8468 15.9312 17 15.5455 17H2.45455C2.06878 17 1.69881 16.8468 1.42603 16.574C1.15325 16.3012 1 15.9312 1 15.5455Z",
    stroke: "#6E8CA0",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1818 5.3636H14.0909M11.1818 11.5454H14.0909M11.1818 13.7272H14.0909M3.90909 5.3636H5.36363M5.36363 5.3636H6.81818M5.36363 5.3636V3.90906M5.36363 5.3636V6.81815M4.33527 13.6647L5.36363 12.6363M5.36363 12.6363L6.39272 11.608M5.36363 12.6363L4.33527 11.608M5.36363 12.6363L6.39272 13.6647",
    stroke: "#6E8CA0",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.67230a64730d30519d7639d827d80e6a.svg";
export { ForwardRef as ReactComponent };